var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4833)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78571 0C1.24694 0 0 1.20857 0 2.7V15.3C0 16.7914 1.24694 18 2.78571 18H23.2143C24.7531 18 26 16.7914 26 15.3V2.7C26 1.20857 24.7531 0 23.2143 0H2.78571ZM1.85714 3.03377V15.0866L9.31808 9.8136L1.85714 3.03377ZM3.43306 16.2H22.5664L15.2662 11.0407L14.7829 11.431C13.7498 12.2652 12.2492 12.2652 11.2161 11.431L10.7327 11.0407L3.43306 16.2ZM24.1429 15.0861V3.03326L16.6819 9.81257L24.1429 15.0861ZM22.785 1.8H3.21498L11.3869 9.22526L12.4057 10.0481C12.7501 10.3263 13.2499 10.3263 13.5948 10.0481L14.6136 9.22526L22.7856 1.8H22.785Z",
    fill: "#E84B31"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.30501e8a61d4cf1b934d4e4a25c74072.svg";
export { ForwardRef as ReactComponent };